/**
 * Global email validation (matches backend utils/emailValidation.js).
 */

export const EMAIL_REGEX =
  /^[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;

const INVALID_LOCAL_CHARS = /[/\\]/;

/**
 * @param {string} value
 * @returns {string|null} error message or null if valid
 */
export function validateEmail(value) {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "Email is required";
  if (trimmed.length > 254) return "Email is too long";
  const at = trimmed.indexOf("@");
  if (at <= 0) return "Enter a valid email address";
  const local = trimmed.slice(0, at);
  const domain = trimmed.slice(at + 1);
  if (INVALID_LOCAL_CHARS.test(local)) return "Email cannot contain / or \\";
  if (local.startsWith(".") || local.endsWith(".") || local.includes("..")) {
    return "Enter a valid email address";
  }
  if (!domain.includes(".") || domain.startsWith(".") || domain.endsWith(".")) {
    return "Enter a valid email address";
  }
  if (!EMAIL_REGEX.test(trimmed)) return "Enter a valid email address";
  return null;
}

export function isValidEmail(value) {
  return validateEmail(value) == null;
}
